//DoctorList.jsx
import React, { useState } from 'react';
import { Grid, styled, Box, Backdrop, CircularProgress } from '@mui/material';
import { Fragment } from 'react';
import { Button, Dialog, DialogContent, DialogTitle } from '@mui/material';
import { useEffect } from 'react';
import UserCard from 'app/views/cards/SpecialistUserCard';
import SpecialistForm from './SpecialistsForm';
import { getAllSpecialistsDetails } from 'app/api-ws/specialists-ws';
import useAuth from 'app/hooks/useAuth';

const ContentBox = styled('div')(({ theme }) => ({
  margin: '30px',
  [theme.breakpoints.down('sm')]: { margin: '16px' }
}));

const SpecialistsList = () => {
  const{user} = useAuth();
  const [openDialog, setOpenDialog] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [specialist, setSpecialist] = useState([]);
  const [doctorName, setDoctorName] = useState('');
  const [email, setEmail] = useState('');
  const [profileImage, setProfileImage] = useState();
  const [phoneNumber, setphoneNumber] = useState();
  const [refAdminId, setrefAdminId] = useState();
  const [centerAddress, setcenterAddress] = useState();
  const [aboutDoctor, setaboutDoctor] = useState();
  const avatar = [
    '/assets/images/avatars/001-man.svg',
    '/assets/images/avatars/002-woman.svg',
    '/assets/images/avatars/003-man-1.svg',
    '/assets/images/avatars/004-bald.svg',
    '/assets/images/avatars/005-man-2.svg',
    '/assets/images/avatars/006-woman-1.svg',
    '/assets/images/avatars/007-woman-2.svg'
  ];
  const cover = ['/assets/images/abstract-bg-1.png'];

  const doctorListWithAvatars = specialist.map((user, index) => ({
    ...user,
    avatar: avatar[index],
    cover: cover[0]
  }));

  const handleOpenDialog = () => {
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
  };

  const handleDialogSubmit = (values) => {
    // console.log('Dialog form values:', values);
    fetchSpecialistDetails();
    handleCloseDialog();
  };

  useEffect(() => {
    fetchSpecialistDetails();
  }, []);

  const fetchSpecialistDetails = () => {
    getAllSpecialistsDetails(user?.authToken)
      .then((res) => {
        setSpecialist(res.data.reverse());
        setIsLoading(false);
      })
      .catch((error) => {
        setIsLoading(false);
        console.log(error);
      });
  };
  if (isLoading) {
    return (
      <div>
        <Backdrop
          sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={isLoading}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      </div>
    );
  }
  return (
    <Fragment>
      <ContentBox className="analytics">
        <Grid container spacing={3}>
          <Box p={4} height="100%">
            <Button onClick={handleOpenDialog} variant="contained" color="primary" style={{backgroundColor : '#66b5a3', color:'white'}}>
              Add Specialist
            </Button>
            <Dialog open={openDialog} onClose={handleCloseDialog}>
              <DialogTitle>Enter Specialist Details</DialogTitle>
              <DialogContent>
                <SpecialistForm
                  fetchSpecialistDetails={fetchSpecialistDetails}
                  handleDialogSubmit={handleDialogSubmit}
                  doctorName={doctorName}
                  setDoctorName={setDoctorName}
                  email={email}
                  setEmail={setEmail}
                  handleCloseDialog={handleCloseDialog}
                  profileImage={profileImage}
                  setProfileImage={setProfileImage}
                  phoneNumber={phoneNumber}
                  setphoneNumber={setphoneNumber}
                  refAdminId={refAdminId}
                  setrefAdminId={setrefAdminId}
                  centerAddress={centerAddress}
                  setcenterAddress={setcenterAddress}
                  aboutDoctor={aboutDoctor}
                  setaboutDoctor={setaboutDoctor}
                />
              </DialogContent>
            </Dialog>
            <Box pt={2} pb={4}>
              <Grid container spacing={3}>
                {doctorListWithAvatars.map((user, index) => (
                  <Grid item md={4} sm={6} xs={12} key={index}>
                    <UserCard fetchSpecialistDetails={fetchSpecialistDetails} user={user} />
                  </Grid>
                ))}
              </Grid>
            </Box>
          </Box>
        </Grid>
      </ContentBox>
    </Fragment>
  );
};

export default SpecialistsList;
